module.exports = __webpack_public_path__ + "img/alipay.c0bb1d22.jpg";